import fetch from '../utils/fetch';
import { rosterUrl } from '../endpoints';
import { memoryCache } from '../utils/memory-cache';
const RosterSdk = require( '@nackle/roster-sdk' );

function RosterService() {
    const sdk = new RosterSdk( rosterUrl, fetch, memoryCache, '' );

    const getTeamMembers = async ( nodeId ) => {
        try {
            const filter = { hierarchyNodeId: nodeId };
            const response = await sdk.searchPersons( {
                personProperties: [ 'emails', 'attributes' ],
                ...filter,
                pageNumber: 1
            } );
            if ( response.success ) {
                return response.persons;
            }
            throw new Error( 'Unsuccessful response from searchPersons' );
        } catch ( error ) {
            console.log( 'ERROR', error );
        }
    };

    return {
        getTeamMembers
    };
}

export default new RosterService();
